<template>
  <div class="pay_ebook_vipspace_container">
    <div class="bookvip">
      <div class="bookvip-item">
        <div class="bookvip-item-header">
          {{ currentInfo.item }}
        </div>
        <div class="line"></div>
        <div class="bookvip-item-content" style="padding-top: 0;">
          <div class="bookvip-item-type pay-info-type">
            <div class="bookvip-item-left">
              <span class="fontcolor bullet">*</span>
              <span class="typelabel">你选择的服务类型:</span>
            </div>
            <el-radio-group v-model="payInfoType" @change="changeCommodityType">
              <template v-for="(item, idx) in saleCommodityOptions">
                <el-radio-button v-show="item.show" :label="item.value" :key="idx">{{ item.label }}</el-radio-button>
              </template>
            </el-radio-group>
          </div>
          <div class="bookvip-item-type">
            <div class="bookvip-item-left">
              <span class="fontcolor bullet">*</span>
              <span class="typelabel">你选择的服务单价:</span>
            </div>
            <span class="fontcolor">{{ unitPrice }}</span
            >元
          </div>
          <div class="bookvip-item-type" v-show="currentInfo.isShowSpaceCapacity">
            <div class="bookvip-item-left">
              <span class="fontcolor bullet">*</span>
              <span class="typelabel">存储空间容量:</span>
            </div>
            <el-input-number v-model="spaceCapacity" :min="1" label=""></el-input-number>
            <span style="margin-left:5px">GB</span>
          </div>
          <div class="bookvip-item-type">
            <div class="bookvip-item-left">
              <span class="fontcolor bullet">*</span>
              <span class="typelabel">你选择的授权时长:</span>
            </div>
            <el-input-number v-model="year" :min="1" label="" :precision="0"></el-input-number>
            <span style="margin-left:5px">年</span>
          </div>
          <div class="bookvip-item-type">
            <div class="bookvip-item-left">
              <span class="fontcolor bullet">*</span>
              <span class="typelabel">你需要支付的金额:</span>
            </div>
            <span class="fontcolor">{{ payMoney }}</span
            >元
          </div>
          <div class="bookvip-item-type">
            <div class="bookvip-item-left">
              <span class="bullet"></span>
              <span class="typelabel fontcolor">续费后到期时间:</span>
            </div>
            <span class="fontcolor">{{ endTime }}</span>
          </div>
        </div>
      </div>
      <div class="bookvip-item">
        <div class="bookvip-item-header">
          支付方式
        </div>
        <div class="line"></div>
        <div class="bookvip-item-content pay pay-type">
          <div>
            <el-radio v-model="payType" label="2">
              <img src="@imgs/wechatPay_vip.png" alt="" />
            </el-radio>
            <!-- <img src="@imgs/wechatPay_vip.png" alt="" /> -->
          </div>
          <div>
            <el-radio v-model="payType" label="1">
              <img src="@imgs/aplipay_vip.png" alt="" />
            </el-radio>
            <!-- <img src="@imgs/aplipay_vip.png" alt="" /> -->
          </div>
        </div>
      </div>
      <div class="bookvip-item">
        <div class="bookvip-item-header">
          发票信息
        </div>
        <div class="line"></div>
        <div class="bookvip-item-content ticket">
          <div class="block">
            <span class="ticketHead">是否要发票</span>
            <el-radio v-model="radio" label="1">是</el-radio>
            <el-radio v-model="radio" label="0">否</el-radio>
          </div>
          <div v-if="radio == 1">
            <!-- 发票介质 -->
            <div class="block" style="height:80px">
              <span class="ticketHead">发票介质</span>
              <span class="ticketCon">电子发票</span>
              <div class="ticketTip eleTic">电子票预计在付款完成后一天内开出，请前往<span @click="goUser">个人中心</span>下载</div>
            </div>
            <!-- 发票类型 -->
            <div class="block">
              <!-- <span class="fontcolor">*</span> -->
              <span class="ticketHead">
                <span class="fontcolor">*</span>
                发票类型</span
              >
              <span class="ticketCon cusInvoice">增值税普通发票</span>
            </div>
            <!-- 发票抬头 -->
            <div class="block">
              <!-- <span class="fontcolor">*</span> -->
              <span class="ticketHead">
                <span class="fontcolor">*</span>
                发票抬头</span
              >
              <el-radio v-model="invoiceTit" label="0">个人</el-radio>
              <el-radio v-model="invoiceTit" label="2">政府或者事业单位</el-radio>
              <el-radio v-model="invoiceTit" label="1">企业</el-radio>
            </div>
            <div v-show="invoiceTit == 0">
              <!-- 抬头名称 -->
              <div class="block">
                <!-- <span class="fontcolor">*</span> -->
                <span class="ticketHead">
                  <span class="fontcolor">*</span>
                  抬头名称</span
                >
                <el-input class="ticketInput" v-model="headerName" placeholder="个人" disabled></el-input>
              </div>
            </div>
            <div v-show="invoiceTit == 1">
              <!-- 企业名称 -->
              <div class="block">
                <!-- <span class="fontcolor">*</span> -->
                <span class="ticketHead">
                  <span class="fontcolor">*</span>
                  企业名称</span
                >
                <el-input class="ticketInput" v-model="enterpriseName" @change="onInputChange($event, 'enterpriseName')"></el-input>
              </div>

              <!-- 纳税人识别号 -->
              <div class="block">
                <!-- <span class="fontcolor">*</span> -->
                <span class="ticketHead">
                  <span class="fontcolor">*</span>
                  纳税人识别号</span
                >
                <el-input class="ticketInput" v-model="TaxpayerNum" @change="onTaxpayerNumChange"></el-input>
              </div>
              <div class="ticketTip">请务必填写正确的企业名称与纳税人识别号，以免影响开票报销</div>
              <!-- 请务必填写正确的企业名称与纳税人识别号，以免影响开票报销 -->
            </div>
            <div v-show="invoiceTit == 2">
              <!-- 抬头名称 -->
              <div class="block">
                <!-- <span class="fontcolor">*</span> -->
                <span class="ticketHead">
                  <span class="fontcolor">*</span>
                  抬头名称</span
                >
                <el-input
                  class="ticketInput"
                  v-model="goverHeaderName"
                  @change="onInputChange($event, 'goverHeaderName')"
                  placeholder="必读：如您单位报销需要填写纳税人识别号，请选择上方发票抬头为企业"
                ></el-input>
              </div>
              <div class="ticketTip">政府或事业单位请填写单位名称</div>
              <!-- 政府或事业单位请填写单位名称 -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="paybutton">
      <el-button class="goPay" @click="pay">去支付</el-button>
    </div>
  </div>
</template>

<script>
import vipUser from '@api/vip'
import { mapState } from 'vuex'
import { isLogin } from '@/utils'
export default {
  name: 'goPayPage',
  data() {
    return {
      year: 1,
      unitPrice: '',
      spaceCapacity: 1, //存储容量
      payType: '1',
      radio: '0', //是否要发票，1代表是、0代表否
      order: '',
      invoiceTit: '1', //发票抬头类型 0代表个人、1代表企业、2代表政府事业单位
      enterpriseName: '', //企业名称
      TaxpayerNum: '', //纳税人识别号
      headerName: '', //个人抬头名称
      goverHeaderName: '', //政府或者事业单位抬头名称
      isDilatation: false,
      currentInfo: {},
      payInfoType: 'elec_book_vip',
      saleCommodityOptions: [
        {
          label: '基础版',
          value: 'elec_book_vip',
          title: '云阅读基础版会员',
          name: '飞翔云阅读基础版会员',
          show: true
        },
        {
          label: '专业版',
          value: 'elec_book_prof',
          title: '云阅读专业版会员',
          name: '飞翔云阅读专业会员',
          show: true
        },
        {
          label: '黄金版',
          value: 'elec_book_gold',
          title: '云阅读黄金版会员',
          name: '飞翔云阅读黄金会员',
          show: false
        },
        {
          label: '铂金版',
          value: 'elec_book_platinum',
          title: '云阅读铂金版会员',
          name: '飞翔云阅读铂金会员',
          show: false
        },
        {
          label: '钻石版',
          value: 'elec_book_diamond',
          title: '云阅读钻石版会员',
          name: '飞翔云阅读钻石会员',
          show: false
        },
        {
          label: '存储空间',
          value: 'elec_book_space',
          title: '云阅读存储空间',
          name: '',
          show: true
        }
      ]
    }
  },
  methods: {
    getMemberVipInfo() {
      const params = { proType: this.payInfoType }
      const request = vipUser.getMemberProInfo
      request(params).then((res) => {
        if (res.status == 200 && res.data.data) {
          this.unitPrice = res.data.data.salePrice
        }
      })
    },

    goUser() {
      window.location.href = `${window.PROJECT_CONFIG.BASE_URL}/ucenter/user.jhtml`
    },
    changeCommodityType(val) {
      this.getMemberVipInfo()
      this.year = 1
      this.currentInfo.item = this.saleCommodityOptions.filter((element, index) => {
        return element.value === val
      })[0].title

      if (val === 'elec_book_space') {
        this.isDilatation = true
        this.spaceCapacity = 1
        this.currentInfo.isShowSpaceCapacity = true
      } else {
        this.isDilatation = false
        this.currentInfo.isShowSpaceCapacity = false
      }
    },
    //只允许输入英文和数字
    onTaxpayerNumChange(str) {
      const arr = str.match(/[a-zA-Z0-9]/g)
      if (arr != null) {
        const txt = arr.join('')
        this.TaxpayerNum = txt
      } else {
        this.TaxpayerNum = ''
      }
    },
    //只允许输入中文、英文、数字、下划线、中划线、中英文小括号、书名号
    onInputChange(str, type) {
      const arr = str.match(/[\u4e00-\u9fa5a-zA-Z0-9_)(）（》《-]/g)
      if (arr != null) {
        const txt = arr.join('')
        this[type] = txt
      } else {
        this[type] = ''
      }
    },
    // 支付生成订单
    pay() {
      if (this.openedMemberType.value !== this.payInfoType && this.payInfoType !== 'elec_book_space' && this.vipInfo.isMember) {
        this.$alert('您已开通云阅读' + this.openedMemberType.label + '会员，如您需在有效期内变更会员档位，请联系010-82531402', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.payType) {
        this.$alert('必须选择支付方式', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (this.radio == 1) {
        if (this.invoiceTit == 1) {
          if (this.enterpriseName == '') {
            this.$alert('请填写企业名称', '提示', {
              confirmButtonText: '确定'
            })
            return
          } else if (this.TaxpayerNum == '') {
            this.$alert('请填写纳税人识别号', '提示', {
              confirmButtonText: '确定'
            })
            return
          } else {
            this.payCon(this.enterpriseName, this.TaxpayerNum)
          }
        } else if (this.invoiceTit == 2) {
          if (this.goverHeaderName == '') {
            this.$alert('请填写抬头名称', '提示', {
              confirmButtonText: '确定'
            })
            return
          } else {
            this.payCon(this.goverHeaderName, '')
          }
        } else if (this.invoiceTit == 0) {
          this.payCon('个人', '')
        }
      } else if (this.radio == 0) {
        this.payCon()
      }
    },
    payCon(goverHeaderName, TaxpayerNum) {
      let params
      if (goverHeaderName || TaxpayerNum) {
        params = {
          loginName: this.userName,
          purLen: this.year.toString(),
          isReceipt: this.radio,
          receiptId: '增值税普通发票',
          receiptTitle: goverHeaderName,
          receiptType: this.invoiceTit,
          taxpayerCode: TaxpayerNum,
          addTaxAddress: '',
          addTaxPhone: '',
          addTaxOpenBank: '',
          addTaxAccount: '',
          addTaxBusinessProve: '',
          addTaxProve: '',
          receiptMedium: 1
        }
      } else {
        params = {
          loginName: this.userName,
          purLen: this.year.toString(),
          isReceipt: this.radio,
          receiptId: '',
          receiptTitle: '',
          receiptType: '',
          taxpayerCode: '',
          addTaxAddress: '',
          addTaxPhone: '',
          addTaxOpenBank: '',
          addTaxAccount: '',
          addTaxBusinessProve: '',
          addTaxProve: '',
          receiptMedium: ''
        }
      }
      let request
      if (this.isDilatation) {
        params.productNum = this.spaceCapacity.toString()
        request = vipUser.getEbookMemberSpaceOrder
      } else {
        params.proType = this.payInfoType
        request = vipUser.getMemberOrder
      }
      request(params).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.order = res.data.data
          let param = {
            orderCode: this.order,
            payType: this.payType
          }
          window.location.href = `${window.PROJECT_CONFIG.BASE_URL}/buy/pay/${param.payType}/${param.orderCode}.jhtml`
        }
      })
    }
  },
  computed: {
    ...mapState('common', ['vipInfo']),
    userName() {
      return localStorage.getItem('username')
    },
    payMoney() {
      return this.isDilatation ? this.unitPrice * this.year * this.spaceCapacity : this.unitPrice * this.year
    },
    openedMemberType() {
      const authProduct = this.vipInfo.authProduct || ''
      if (!authProduct) return ''
      return this.saleCommodityOptions.filter((element) => {
        return element.name === authProduct
      })[0]
    },
    endTime() {
      let time
      if (this.openedMemberType.value === this.payInfoType) {
        time = new Date(this.vipInfo.endTime)
      } else {
        time = new Date()
      }
      return `${time.getFullYear() + this.year}年${time.getMonth() + 1}月${time.getDate()}日`
    }
  },
  mounted() {
    isLogin()
    this.payInfoType = this.$route.query.buyType || 'elec_book_vip'
    this.changeCommodityType(this.payInfoType)
    this.$store.dispatch('common/getVipInfo')
  }
}
</script>

<style lang="scss">
.pay_ebook_vipspace_container {
  width: 100%;
  padding-top: 25px;
  overflow: auto;
  .bookvip {
    width: 1100px;
    margin: 20px auto;
    .crumb {
      font-size: 16px;
      color: #515151;
      margin-bottom: 15px;
    }
    .bookvip-item {
      padding: 20px;
      margin-bottom: 20px;
      background: #f4f4f4;
      .line {
        width: 1000px;
        height: 1px;
        background: #cccccc;
        margin: 10px 0 20px 0;
      }
      .bookvip-item-header {
        font-size: 18px;
        color: #3a3a3a;
      }
      .bookvip-item-content {
        // vertical-align: middle;
        padding: 10px 0 0 30px;
        .bookvip-item-type {
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          .bullet {
            color: #999;
            display: inline-block;
            width: 8px;
          }
          .fontcolor {
            color: #df5813;
            margin-right: 5px;
          }
          .typelabel {
            margin-right: 20px;
            // width: 133px;
            display: inline-block;
            // text-align: right;
          }
          .bookvip-tip {
            margin-left: 13px;
          }
          .bookvip-item-left {
            display: inline-block;
            width: 168px;
            text-align: right;
          }
        }
      }
      .pay {
        display: flex;
        div {
          display: flex;
          margin-right: 15px;
          align-items: center;
          .el-radio__label {
            color: #fff;
          }
        }
      }
      .ticket {
        padding-left: 70px;
        .el-radio {
          margin-left: 20px;
          color: #333;
        }
        .el-radio__input {
          margin-right: 0 !important;
        }
        .el-radio__label {
          font-size: 16px;
        }
        .block {
          height: 50px;
          .ticketHead {
            display: inline-block;
            text-align: right;
            width: 120px;
            color: #999;
            .fontcolor {
              color: #df5813;
              margin-right: 5px;
            }
          }
          .ticketCon {
            display: inline-block;
            margin-left: 20px;
            color: #333;
          }
          .cusInvoice {
            width: 130px;
            text-align: center;
            line-height: 28px;
            cursor: pointer;
            border: 1px solid #df5813;
            background: url(../assets/imgs/select.png) right bottom no-repeat;
          }
          .ticketInput {
            width: 650px;
            margin-left: 20px;
          }
          .eleTic {
            margin-top: 10px;
            color: #999;
            span {
              color: #333;
              cursor: pointer;
            }
          }
        }
        .ticketTip {
          padding-left: 140px;
          height: 40px;
          line-height: 40px;
          color: red;
        }
      }
    }
  }
  .paybutton {
    margin: 50px auto;
    width: 150px;
    .goPay {
      width: 150px;
      height: 50px;
      color: #fff;
      background: #df5813;
    }
  }
}
</style>

<style lang="scss" scoped>
.bookvip-item-content {
  font-family: FZLTZHJW--GB1-0, FZLTZHJW--GB1;
  color: #3a3a3a;
  font-size: 16px;
}
.pay-type {
  /deep/ .el-radio {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 25px;
  }
}
.pay-info-type {
  margin-bottom: 10px;
  // height: 50px !important;
  // line-height: 50px !important;
  /deep/ .el-radio-button {
    width: 130px;
    height: 50px;
    margin-right: 20px;
    border: 1px solid #cecece;
    .el-radio-button__inner {
      width: 100%;
      height: 100%;
      font-size: 18px;
      line-height: 26px;
      font-weight: normal;
      color: #3a3a3a;
      border-radius: 0 !important;
      border: none !important;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #fff;
      color: #df5813;
      border-color: #df5813;
    }
    &.is-active {
      border-color: #df5813;
    }
  }
}
/deep/ .el-input-number {
  width: 140px;
  .el-input-number__decrease,
  .el-input-number__increase {
    background-color: #cecece;
    i {
      color: #3a3a3a;
    }
  }
  .el-input {
    // width: 140px;
    .el-input__inner {
      padding: 0 40px;
    }
  }
}
</style>
